module.exports = __webpack_public_path__ + "img/4_151.78b83f10.png";